import { useCallback } from 'react';
import {
  useMessageDispatch,
  UseMessageDispatchProps,
} from './useEddyMessaging';
import useMessageHandler from './useEddyMessaging/useMessageHandler';

type PauseMessageData = { type: 'pause' };

export type UsePauseMessagingProps = Pick<UseMessageDispatchProps, 'iframe'> & {
  onPause: () => void;
};

export default function usePauseMessaging({
  iframe,
  onPause,
}: UsePauseMessagingProps) {
  const dispatch = useMessageDispatch({ iframe });

  const pause = useCallback(() => {
    dispatch({
      type: 'pause',
    });
  }, [dispatch]);

  useMessageHandler<PauseMessageData>(
    e => {
      if (e.data.type === 'pause') {
        onPause?.();
      }
    },
    { iframe },
  );

  return { pause };
}
